import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { DirectionBadge, LiveBadge } from "../components/Badges";
import { ErrorBanner } from "../components/ErrorBanner";
import { SearchInput } from "../components/SearchInput";
import { useCatalog } from "../context/CatalogContext";
import { matchesQuery, trainLabel } from "../api/format";

export function TrainsList() {
  const { trains, loading, error, reload } = useCatalog();
  const [q, setQ] = useState("");
  const rows = useMemo(
    () => trains.filter((t) => matchesQuery(q, t.train_id, t.train_number, t.train_name, t.train_name_ur, t.description, t.direction)),
    [trains, q],
  );

  return (
    <div className="page">
      <div className="page-head">
        <h1>Trains</h1>
        <SearchInput value={q} onChange={setQ} placeholder="Search number, name, Urdu, direction…" />
      </div>
      <ErrorBanner error={error} onRetry={reload} />
      {loading ? <p className="muted">Loading trains…</p> : null}
      {!loading && rows.length === 0 ? <p className="muted">No trains.</p> : null}
      {rows.length > 0 ? (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Train</th>
                <th>Dir</th>
                <th>Urdu</th>
                <th>Live GPS</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((t) => (
                <tr key={t.train_id}>
                  <td>
                    <Link to={`/trains/${t.train_id}`}>{trainLabel(t)}</Link>
                  </td>
                  <td>
                    <DirectionBadge direction={t.direction} />
                  </td>
                  <td className="urdu">{t.train_name_ur || "—"}</td>
                  <td>
                    <LiveBadge live={Boolean(t.is_live)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
